import { Link } from '@routable/gross-ds';
import React from 'react';

import { PLATFORM_DISPLAY_SHORT_NAME, PLATFORM_URL } from 'constants/platform';

import './PoweredByWordmark.scss';

/**
 * Wordmark used in the external footer to throwback to Routable on-click, otherwise we whitelabel the external flow.
 */
const PoweredByWordmark = () => (
  <Link
    className="powered-by-wordmark no-underline"
    href={PLATFORM_URL}
    openInNewTab
    showArrowIcon={false}
    size="small"
    variant="black"
  >
    <span className="powered-by-wordmark__logo icon-ic-logo-letter" />

    {`Powered by ${PLATFORM_DISPLAY_SHORT_NAME}`}
  </Link>
);

export default PoweredByWordmark;
